import { Fragment } from "react";
import ChevronRight from "components/icons/24/actions/chevron-right.svg";
import OverflowTooltip from "components/elements/Tooltips/OverflowTooltip";

export type AutodeskCrumb = {
  label: string;
  onClick?(): void;
};

/** The last crumb is where the user is, so it is shown but not clickable. */
export default function AutodeskBreadcrumbs(p: { crumbs: AutodeskCrumb[] }) {
  return (
    <nav className="flex flex-wrap items-center gap-2 text-sm">
      {p.crumbs.map((crumb, index) => (
        <Fragment key={index}>
          {index > 0 && (
            <ChevronRight className="block w-5 py-1 text-icon-normal" />
          )}
          {index === p.crumbs.length - 1 ? (
            <OverflowTooltip className="max-w-48 rounded-md bg-primary-500 px-1.5 py-1 text-white">
              {crumb.label}
            </OverflowTooltip>
          ) : (
            <button
              type="button"
              className="max-w-48 rounded-md py-1 outline-offset-4 enabled:hover:underline disabled:text-gray-400"
              disabled={!crumb.onClick}
              onClick={crumb.onClick}
            >
              <OverflowTooltip>{crumb.label}</OverflowTooltip>
            </button>
          )}
        </Fragment>
      ))}
    </nav>
  );
}
